
<script>
// import FilialForm from "../forms/filial-form";

export default {
  components: {
  },

  props: {
  },

  data() {
    return {
    };
  },

  methods: {

  },

  computed: {

  },

  created() {

  },

  mounted() {

  }

};
</script>

<template>
  <div class="container">
    <div class="col-12 d-flex justify-content-between shadow-sm" style=" align-items: center; margin: 10px 0px">
      <div class="col-12 d-flex justify-content-center align-items-center shadow" style="background-color: white; ">
        <img src="https://s3.us-east-1.amazonaws.com/novo.notabrasil.com.br-bucket/imagens/banners/banner_nb_asaas.png"
          alt="Comunicado novo meio de pagamento" style="" />
      </div>
    </div>
  </div>
</template>



// WEBPACK FOOTER //
// src/components/alert-asaas.vue